import React from 'react';

import Suggestions from './Suggestions';
import SuggestionFragment from './SuggestionFragment';

import TettraIndex from '../../../schemas/TettraUniSchema';
import { RESOURCE_MODEL } from '../../../utilities/CONSTANTS';

const team = typeof window.teamId !== 'undefined' ? window.teamId : null;

const MAX_SUGGESTIONS = 5;

const source = 'InternalResourceSuggestions.jsx';

const getInternalResourceSuggestions = async (searchText) => {
    try {
        return await TettraIndex.Search(searchText, MAX_SUGGESTIONS * 2, team, source, [RESOURCE_MODEL.PAGE, RESOURCE_MODEL.QUESTION]);
    } catch (e) {
        console.error(e);
        return [];
    }
};

const InternalResourceSuggestions = (props) => (
    <div className="suggestions internal-suggestions">
        <Suggestions
            async
            getSuggestions={getInternalResourceSuggestions}
            selectSuggestion={props.insertPageReference}
            renderSuggestion={suggestion => <SuggestionFragment suggestion={suggestion} />}
            {...props}
        />
    </div>
);

export default InternalResourceSuggestions;
